(function() {
  const FILTER_PARAM = 'filter.p.m.custom.quick_wh';
  const STORAGE_KEY = 'deliveryLocation';

  const DOM = {
    grid: document.querySelector('.collection.section--padding'),
    statusContainer: document.getElementById('qd-status-container'),
    loadingState: document.getElementById('qd-loading'),
    errorState: document.getElementById('qd-error'),
    errorMessage: document.getElementById('qd-error-message'),
    popupTrigger: document.querySelector('.delivery-location-selector, .delivery-location-selector--gradient'),
    modal: document.querySelector('[data-delivery-location-modal]')
  };

  // Holds new location data in memory until the modal finishes closing
  let pendingLocationData = null;

  function getDeliveryData() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY) || localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  function setViewState(state, msg = '') {
    if (!DOM.statusContainer || !DOM.grid) return;

    if (state === 'show') {
      DOM.statusContainer.classList.add('qd-hidden');
      DOM.grid.style.setProperty('display', 'block', 'important');
    } else if (state === 'error') {
      if (DOM.loadingState) DOM.loadingState.classList.add('qd-hidden');
      if (DOM.errorState) DOM.errorState.classList.remove('qd-hidden');
      if (DOM.errorMessage && msg) DOM.errorMessage.textContent = msg;
      
      // Enforce display: none so unserviceable catalogs never render
      DOM.grid.style.setProperty('display', 'none', 'important');
    }
  }

  function evaluateAndRoute(deliveryData) {
    // 1. Missing Location (User aborted popup)
    if (!deliveryData?.pincode) {
      setViewState('error', 'Please select a delivery location to check Mini Rush availability.');
      return false;
    }

    // 2. Unserviceable Location
    if (!deliveryData.quickDeliveryServiceable || !deliveryData.warehousePincode) {
      setViewState('error', 'Mini Rush is not available for your current location.');
      window.location.replace("https://miniklub.in/pages/miniklub-baby-kids-apparel");
      /*
      // Strip filter from URL if it exists, but keep the catalog hidden
      const currentUrl = new URL(window.location.href);
      if (currentUrl.searchParams.has(FILTER_PARAM)) {
        currentUrl.searchParams.delete(FILTER_PARAM);
        window.location.replace(currentUrl.toString());
      }*/
      return false; 
    }

    // 3. Serviceable - Apply Filter & Redirect
    const currentUrl = new URL(window.location.href);
    const targetPincode = String(deliveryData.warehousePincode);

    if (currentUrl.searchParams.get(FILTER_PARAM) !== targetPincode) {
      currentUrl.searchParams.set(FILTER_PARAM, targetPincode);
      window.location.replace(currentUrl.toString());
      return true; // Execution halts as page unloads
    }

    // 4. Serviceable & Already Filtered
    setViewState('show');
    return true;
  }

  function initQuickDelivery() {
    if (!DOM.grid) return;

    // Fast-fail for bots
    if (/bot|google|baidu|bing|msn|duckduckbot|teoma|slurp|yandex/i.test(navigator.userAgent)) {
      return setViewState('show');
    }

    // --- PERMANENT EVENT LISTENERS ---

    // 1. Silently capture validation successes whenever they happen
    document.addEventListener('delivery-location:updated', (e) => {
      pendingLocationData = e.detail || getDeliveryData();
    });

    // 2. Permanently watch the modal's state
    if (DOM.modal) {
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.attributeName === 'aria-hidden') {
            const isClosed = DOM.modal.getAttribute('aria-hidden') === 'true';
            
            if (isClosed) {
              // The exact moment the modal closes, fire the routing logic.
              if (pendingLocationData) {
                // User submitted a new valid pincode
                evaluateAndRoute(pendingLocationData);
                pendingLocationData = null; // Clear memory
              } else {
                // User clicked "X" without entering a new pincode
                evaluateAndRoute(getDeliveryData());
              }
            }
          }
        }
      });
      observer.observe(DOM.modal, { attributes: true });
    }

    // --- INITIAL LOAD BEHAVIOR ---

    const initialData = getDeliveryData();

    if (initialData?.pincode) {
      // Data exists -> Route immediately
      evaluateAndRoute(initialData);
    } else if (DOM.popupTrigger) {
      // No data -> Auto-open popup
      setTimeout(() => DOM.popupTrigger.click(), 300);
    } else {
      setViewState('error', 'Please set your delivery pincode to view eligible Mini Rush products.');
    }
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickDelivery);
  } else {
    initQuickDelivery();
  }
})();